angular.module('smartorg.r6.mgmts.portfolioConfiguration').directive('portfolioConfiguration', [function () {
        return {
            restrict: 'E',
            template: require('../../template/portfolio-configuration.html'),
            scope: {
                astro: '=?',
                showAlert: '&?',
                reloadAction: '&?'
            },
            link: function (scope) {
                scope.$on('manage:PortfolioConfiguration', function (event, args) {
                    scope.isChart = args.isChart;
                    scope.treeID = args.portfolioConfig.treeID;
                    scope.saveGlobally = args.saveGlobally;
                    scope.showInputConfig = args.showInputConfig;
                    scope.origPortfolioConfig = args.portfolioConfig;
                    scope.tableDecimalList = ['Default', 0, 1, 2, 3, 4, 5];
                    scope.chartDecimalList = ['Default', 0, 1, 2, 3, 4, 5];
                    if (localStorage.getItem('PortfolioConfig') &&
                        scope.treeID in JSON.parse(localStorage.getItem('PortfolioConfig'))) {
                        scope.sessionPortfolioConfig = JSON.parse(localStorage.getItem('PortfolioConfig'))[scope.treeID];
                        scope.chartConfig = scope.sessionPortfolioConfig['chart'];
                        scope.tableConfig = scope.sessionPortfolioConfig['table'];
                        scope.timestampConfig = scope.sessionPortfolioConfig['timestamp'] || args.portfolioConfig.timestamp;
                        scope.inputScreenConfig = scope.sessionPortfolioConfig['inputScreen'] || args.portfolioConfig.inputScreen;
                        if (!('groupByDisplay' in scope.chartConfig)) {
                            scope.chartConfig.groupByDisplay = "false";
                        }
                        scope.dirtyBySession = scope.checkDirtyBySession();
                    }
                    else {
                        scope.dirtyBySession = false;
                        scope.chartConfig = args.portfolioConfig.chart;
                        scope.tableConfig = args.portfolioConfig.table;
                        scope.timestampConfig = args.portfolioConfig.timestamp;
                        scope.inputScreenConfig = args.portfolioConfig.inputScreen;
                    }
                    scope.origChartConfig = angular.copy(scope.chartConfig);
                    scope.origTableConfig = angular.copy(scope.tableConfig);
                    scope.origTimestampConfig = angular.copy(scope.timestampConfig);
                    scope.origInputScreenConfig = angular.copy(scope.inputScreenConfig);
                    scope.showTable = scope.chartConfig.showTable !== "false";
                    scope.origShowTable = angular.copy(scope.showTable);
                    scope.showLabels = scope.chartConfig.showLabels !== "false";
                    scope.origShowLabels = angular.copy(scope.showLabels);
                    scope.showTooltip = scope.chartConfig.showTooltip !== "false";
                    scope.origShowTooltip = angular.copy(scope.showTooltip);
                    scope.groupByDisplay = scope.chartConfig.groupByDisplay !== "false";
                    scope.origGroupByDisplay = angular.copy(scope.groupByDisplay);
                    scope.showChartExplanation = scope.chartConfig.showChartExplanation !== "false";
                    scope.origShowChartExplanation = angular.copy(scope.showChartExplanation);
                    scope.showInputScreenProbForm = scope.inputScreenConfig.showInputScreenProbForm !== "false";
                    scope.origShowInputScreenProbForm = angular.copy(scope.showInputScreenProbForm);
                    scope.showInputScreenRangeForm = scope.inputScreenConfig.showInputScreenRangeForm !== "false";
                    scope.origShowInputScreenRangeForm = angular.copy(scope.showInputScreenRangeForm);
                    scope.dirty = false;
                    setTimeout(function () {
                        scope.$apply();
                    });
                    $('#configurePortfolioModal').modal('show');
                });
                scope.checkDirtyBySession = function () {
                    if (scope.origPortfolioConfig.chart.showTooltip !== scope.sessionPortfolioConfig.chart.showTooltip) {
                        return true;
                    }
                    else if (scope.origPortfolioConfig.chart.showTable !== scope.sessionPortfolioConfig.chart.showTable) {
                        return true;
                    }
                    else if (scope.origPortfolioConfig.chart.showLabels !== scope.sessionPortfolioConfig.chart.showLabels) {
                        return true;
                    }
                    else if (scope.origPortfolioConfig.chart.decimals !== scope.sessionPortfolioConfig.chart.decimals) {
                        return true;
                    }
                    else if (scope.origPortfolioConfig.chart.charsInLabel !== scope.sessionPortfolioConfig.chart.charsInLabel) {
                        return true;
                    }
                    else if (scope.origPortfolioConfig.chart.verticalDivider !== scope.sessionPortfolioConfig.chart.verticalDivider) {
                        return true;
                    }
                    else if (scope.origPortfolioConfig.chart.groupByDisplay !== scope.sessionPortfolioConfig.chart.groupByDisplay) {
                        return true;
                    }
                    else if (scope.origPortfolioConfig.table.decimals !== scope.sessionPortfolioConfig.table.decimals) {
                        return true;
                    }
                    else if (scope.origPortfolioConfig.chart.showChartExplanation !== scope.sessionPortfolioConfig.chart.showChartExplanation) {
                        return true;
                    }
                    else if (scope.origPortfolioConfig.inputScreen.showInputScreenProbForm !== scope.sessionPortfolioConfig.inputScreen.showInputScreenProbForm) {
                        return true;
                    }
                    else if (scope.origPortfolioConfig.inputScreen.showInputScreenRangeForm !== scope.sessionPortfolioConfig.inputScreen.showInputScreenRangeForm) {
                        return true;
                    }
                    return false;
                };
                scope.checkDirty = function () {
                    if ((scope.chartConfig.charsInLabel == null) ||
                        (scope.chartConfig.decimals == null) ||
                        (scope.chartConfig.verticalDivider == null) ||
                        (scope.tableConfig.decimals == null) ||
                        (scope.timestampConfig.timestampMode == null)) {
                        scope.dirty = false;
                    }
                    else {
                        scope.dirty = (scope.chartConfig.charsInLabel !== scope.origChartConfig.charsInLabel) ||
                            (scope.chartConfig.decimals !== scope.origChartConfig.decimals) ||
                            (scope.chartConfig.verticalDivider !== scope.origChartConfig.verticalDivider) ||
                            (scope.groupByDisplay !== scope.origGroupByDisplay) ||
                            (scope.showTable !== scope.origShowTable) ||
                            (scope.showLabels !== scope.origShowLabels) ||
                            (scope.showTooltip !== scope.origShowTooltip) ||
                            (scope.tableConfig.decimals !== scope.origTableConfig.decimals) ||
                            (scope.timestampConfig.timestampMode !== scope.origTimestampConfig.timestampMode) ||
                            (scope.showChartExplanation !== scope.origShowChartExplanation) ||
                            (scope.showInputScreenProbForm !== scope.origShowInputScreenProbForm) ||
                            (scope.showInputScreenRangeForm !== scope.origShowInputScreenRangeForm);
                    }
                    if (scope.sessionPortfolioConfig) {
                        scope.dirtyBySession = scope.checkDirtyBySession();
                    }
                };
                var getPortfolioConfigForSaving = function () {
                    scope.chartConfig.showTable = scope.showTable ? "true" : "false";
                    scope.chartConfig.showLabels = scope.showLabels ? "true" : "false";
                    scope.chartConfig.showTooltip = scope.showTooltip ? "true" : "false";
                    scope.chartConfig.groupByDisplay = scope.groupByDisplay ? "true" : "false";
                    scope.chartConfig.showChartExplanation = scope.showChartExplanation ? "true" : "false";
                    scope.inputScreenConfig.showInputScreenProbForm = scope.showInputScreenProbForm ? "true" : "false";
                    scope.inputScreenConfig.showInputScreenRangeForm = scope.showInputScreenRangeForm ? "true" : "false";
                    var portfolioConfig = {};
                    if (localStorage.getItem('PortfolioConfig')) {
                        portfolioConfig = JSON.parse(localStorage.getItem('PortfolioConfig'));
                    }
                    portfolioConfig[scope.treeID] = {
                        chart: scope.chartConfig,
                        table: scope.tableConfig,
                        timestamp: scope.timestampConfig,
                        inputScreen: scope.inputScreenConfig,
                        treeID: scope.treeID
                    };
                    return portfolioConfig;
                };
                scope.savePortfolioConfig = function () {
                    var portfolioConfig = getPortfolioConfigForSaving();
                    scope.astro.savePortfolioConfig(scope.treeID, portfolioConfig).then(function () {
                        scope.origChartConfig = angular.copy(scope.chartConfig);
                        scope.origTableConfig = angular.copy(scope.tableConfig);
                        scope.origTimestampConfig = angular.copy(scope.timestampConfig);
                        scope.origInputScreenConfig = angular.copy(scope.inputScreenConfig);
                        scope.dirty = false;
                        localStorage.setItem('PortfolioConfig', JSON.stringify(portfolioConfig));
                        scope.reloadAction();
                    })["catch"](function (err) {
                        scope.showAlert("danger", "Server Error: " + err, "Unable to save chart configuration.");
                    });
                };
                scope.applyToCurrentSession = function () {
                    var portfolioConfig = getPortfolioConfigForSaving();
                    localStorage.setItem('PortfolioConfig', JSON.stringify(portfolioConfig));
                    scope.reloadAction();
                };
                scope.resetPortfolioConfig = function () {
                    scope.chartConfig = scope.origChartConfig;
                    scope.showTable = scope.origChartConfig.showTable !== "false";
                    scope.showLabels = scope.origChartConfig.showLabels !== "false";
                    scope.tableConfig = scope.origTableConfig;
                    scope.timestampConfig = scope.origTimestampConfig;
                    scope.showChartExplanation = scope.origChartConfig.showChartExplanation !== "false";
                    scope.showInputScreenProbForm = scope.origInputScreenConfig.showInputScreenProbForm !== "false";
                    scope.showInputScreenRangeForm = scope.origInputScreenConfig.showInputScreenRangeForm !== "false";
                    scope.dirty = false;
                };
            }
        };
    }]);
//# sourceMappingURL=portfolio-configuration-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/portfolio-configuration/app/js/plumbing/portfolio-configuration-directive.js